var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 75,
    viewBox: "0 0 253 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.63 75H9.37037C4.12296 75 0 70.875 0 65.625V9.375C0 4.125 4.12296 0 9.37037 0H243.63C248.877 0 253 4.125 253 9.375V65.625C253 70.875 248.877 75 243.63 75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.63 1.5C247.94 1.5 251.501 5.0625 251.501 9.375V65.625C251.501 69.9375 247.94 73.5 243.63 73.5H9.37037C5.06 73.5 1.49926 69.9375 1.49926 65.625V9.375C1.49926 5.0625 5.06 1.5 9.37037 1.5H243.63ZM243.63 0H9.37037C4.12296 0 0 4.3125 0 9.375V65.625C0 70.875 4.12296 75 9.37037 75H243.63C248.877 75 253 70.875 253 65.625V9.375C253 4.3125 248.877 0 243.63 0Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8314 19.125C88.8314 20.625 88.4565 21.9375 87.5195 22.875C86.3951 24 85.0832 24.5625 83.3965 24.5625C81.7099 24.5625 80.398 24 79.2736 22.875C78.1491 21.75 77.5869 20.4375 77.5869 18.75C77.5869 17.0625 78.1491 15.75 79.2736 14.625C80.398 13.5 81.7099 12.9375 83.3965 12.9375C84.1462 12.9375 84.8958 13.125 85.6454 13.5C86.3951 13.875 86.9573 14.25 87.3321 14.8125L86.3951 15.75C85.6454 14.8125 84.7084 14.4375 83.3965 14.4375C82.2721 14.4375 81.1477 14.8125 80.398 15.75C79.461 16.5 79.0862 17.625 79.0862 18.9375C79.0862 20.25 79.461 21.375 80.398 22.125C81.3351 22.875 82.2721 23.4375 83.3965 23.4375C84.7084 23.4375 85.6454 23.0625 86.5825 22.125C87.1447 21.5625 87.5195 20.8125 87.5195 19.875H83.3965V18.375H88.8314C88.8314 18.5625 88.8314 18.9375 88.8314 19.125Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4523 14.4375H92.3923V18H97.0775V19.3125H92.3923V22.875H97.4523V24.375H90.8931V13.125H97.4523V14.4375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.636 24.375H102.137V14.4375H98.9512V13.125H106.822V14.4375H103.636V24.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.257 24.375V13.125H113.757V24.375H112.257Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.129 24.375H118.629V14.4375H115.443V13.125H123.127V14.4375H119.941V24.375H120.129Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.932 22.875C136.808 24 135.496 24.5625 133.809 24.5625C132.122 24.5625 130.811 24 129.686 22.875C128.562 21.75 128 20.4375 128 18.75C128 17.0625 128.562 15.75 129.686 14.625C130.811 13.5 132.122 12.9375 133.809 12.9375C135.496 12.9375 136.808 13.5 137.932 14.625C139.057 15.75 139.619 17.0625 139.619 18.75C139.619 20.4375 139.057 21.75 137.932 22.875ZM130.811 21.9375C131.56 22.6875 132.685 23.25 133.809 23.25C134.934 23.25 136.058 22.875 136.808 21.9375C137.557 21.1875 138.12 20.0625 138.12 18.75C138.12 17.4375 137.745 16.3125 136.808 15.5625C136.058 14.8125 134.934 14.25 133.809 14.25C132.685 14.25 131.56 14.625 130.811 15.5625C130.061 16.3125 129.499 17.4375 129.499 18.75C129.499 20.0625 129.874 21.1875 130.811 21.9375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.68 24.375V13.125H143.367L148.802 21.9375V19.6875V13.125H150.301V24.375H148.802L142.992 15.1875V17.4375V24.375H141.68Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.624 40.875C123.127 40.875 119.566 44.25 119.566 48.9375C119.566 53.4375 123.127 57 127.624 57C132.122 57 135.683 53.625 135.683 48.9375C135.683 44.0625 132.122 40.875 127.624 40.875ZM127.624 53.625C125.188 53.625 123.127 51.5625 123.127 48.75C123.127 45.9375 125.188 43.875 127.624 43.875C130.061 43.875 132.122 45.75 132.122 48.75C132.122 51.5625 130.061 53.625 127.624 53.625ZM110.196 40.875C105.698 40.875 102.137 44.25 102.137 48.9375C102.137 53.4375 105.698 57 110.196 57C114.693 57 118.254 53.625 118.254 48.9375C118.254 44.0625 114.693 40.875 110.196 40.875ZM110.196 53.625C107.759 53.625 105.698 51.5625 105.698 48.75C105.698 45.9375 107.759 43.875 110.196 43.875C112.632 43.875 114.693 45.75 114.693 48.75C114.693 51.5625 112.632 53.625 110.196 53.625ZM89.3933 43.3125V46.6875H97.4518C97.2644 48.5625 96.5148 50.0625 95.5778 51C94.4533 52.125 92.5792 53.4375 89.3933 53.4375C84.3333 53.4375 80.5852 49.5 80.5852 44.4375C80.5852 39.375 84.5207 35.4375 89.3933 35.4375C92.017 35.4375 94.0785 36.5625 95.5778 37.875L98.014 35.4375C95.9526 33.5625 93.3289 32.0625 89.5807 32.0625C82.834 32.0625 77.0244 37.6875 77.0244 44.4375C77.0244 51.1875 82.834 56.8125 89.5807 56.8125C93.3289 56.8125 95.9526 55.6875 98.2015 53.25C100.45 51 101.2 47.8125 101.2 45.375C101.2 44.625 101.2 43.875 101.013 43.3125H89.3933ZM174.476 45.9375C173.727 44.0625 171.853 40.875 167.73 40.875C163.607 40.875 160.233 44.0625 160.233 48.9375C160.233 53.4375 163.607 57 168.104 57C171.665 57 173.914 54.75 174.664 53.4375L172.04 51.5625C171.103 52.875 169.978 53.8125 168.104 53.8125C166.23 53.8125 165.106 53.0625 164.169 51.375L174.851 46.875L174.476 45.9375ZM163.607 48.5625C163.607 45.5625 166.043 43.875 167.73 43.875C169.041 43.875 170.353 44.625 170.728 45.5625L163.607 48.5625ZM154.798 56.25H158.359V32.8125H154.798V56.25ZM149.176 42.5625C148.239 41.625 146.74 40.6875 144.866 40.6875C140.93 40.6875 137.182 44.25 137.182 48.75C137.182 53.25 140.743 56.625 144.866 56.625C146.74 56.625 148.239 55.6875 148.989 54.75H149.176V55.875C149.176 58.875 147.49 60.5625 144.866 60.5625C142.804 60.5625 141.305 59.0625 140.93 57.75L137.932 59.0625C138.869 61.125 141.118 63.75 145.053 63.75C149.176 63.75 152.55 61.3125 152.55 55.5V41.25H149.176V42.5625ZM145.053 53.625C142.617 53.625 140.556 51.5625 140.556 48.75C140.556 45.9375 142.617 43.875 145.053 43.875C147.49 43.875 149.364 45.9375 149.364 48.75C149.364 51.5625 147.49 53.625 145.053 53.625ZM190.781 32.8125H182.347V56.25H185.908V47.4375H190.781C194.716 47.4375 198.464 44.625 198.464 40.125C198.464 35.625 194.716 32.8125 190.781 32.8125ZM190.968 44.0625H185.908V36H190.968C193.592 36 195.091 38.25 195.091 39.9375C194.904 42 193.404 44.0625 190.968 44.0625ZM212.52 40.6875C209.896 40.6875 207.273 41.8125 206.336 44.25L209.521 45.5625C210.271 44.25 211.396 43.875 212.707 43.875C214.581 43.875 216.268 45 216.456 46.875V47.0625C215.893 46.6875 214.394 46.125 212.895 46.125C209.521 46.125 206.148 48 206.148 51.375C206.148 54.5625 208.959 56.625 211.958 56.625C214.394 56.625 215.518 55.5 216.456 54.375H216.643V56.25H220.016V47.25C219.641 43.125 216.456 40.6875 212.52 40.6875ZM212.145 53.625C211.021 53.625 209.334 53.0625 209.334 51.5625C209.334 49.6875 211.396 49.125 213.082 49.125C214.581 49.125 215.331 49.5 216.268 49.875C215.893 52.125 214.019 53.625 212.145 53.625ZM231.823 41.25L227.887 51.375H227.7L223.577 41.25H219.829L226.013 55.5L222.453 63.375H226.013L235.571 41.25H231.823ZM200.338 56.25H203.899V32.8125H200.338V56.25Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4904 14.0625C18.9281 14.625 18.7407 15.5625 18.7407 16.6875V58.125C18.7407 59.25 19.1155 60.1875 19.6778 60.75L19.8652 60.9375L43.1037 37.6875V37.5V37.3125L19.4904 14.0625Z",
    fill: "url(#paint0_linear_4873_16118)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6002 45.5625L42.9165 37.875V37.5V37.3125L50.6002 29.625L50.7876 29.8125L59.9706 35.0625C62.5943 36.5625 62.5943 39 59.9706 40.5L50.6002 45.5625Z",
    fill: "url(#paint1_linear_4873_16118)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7873 45.375L42.9162 37.5L19.4902 60.9375C20.4273 61.875 21.7391 61.875 23.4258 61.125L50.7873 45.375Z",
    fill: "url(#paint2_linear_4873_16118)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7873 29.625L23.4258 14.0625C21.7391 13.125 20.4273 13.3125 19.4902 14.25L42.9162 37.5L50.7873 29.625Z",
    fill: "url(#paint3_linear_4873_16118)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.5999 45.1875L23.4258 60.5625C21.9265 61.5 20.6147 61.3125 19.6776 60.5625L19.4902 60.75L19.6776 60.9375C20.6147 61.6875 21.9265 61.875 23.4258 60.9375L50.5999 45.1875Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M19.4904 60.5625C18.9281 60 18.7407 59.0625 18.7407 57.9375V58.125C18.7407 59.25 19.1155 60.1875 19.6778 60.75V60.5625H19.4904Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M59.9705 39.9375L50.6001 45.1875L50.7875 45.375L59.9705 40.125C61.2823 39.375 61.8445 38.4375 61.8445 37.5C61.8445 38.4375 61.0949 39.1875 59.9705 39.9375Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M23.4259 14.25L59.9704 35.0625C61.0948 35.8125 61.8444 36.5625 61.8444 37.5C61.8444 36.5625 61.2822 35.625 59.9704 34.875L23.4259 14.0625C20.8022 12.5625 18.7407 13.6875 18.7407 16.6875V16.875C18.7407 14.0625 20.8022 12.75 23.4259 14.25Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4873_16118",
    x1: 40.854,
    y1: 16.3309,
    x2: 9.38705,
    y2: 47.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4873_16118",
    x1: 63.4082,
    y1: 37.5028,
    x2: 18.0614,
    y2: 37.5028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4873_16118",
    x1: 46.5273,
    y1: 41.8054,
    x2: 3.85551,
    y2: 84.4561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4873_16118",
    x1: 13.6754,
    y1: 0.330558,
    x2: 32.7302,
    y2: 19.3758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.b7827a33ebbb4d73ea972062c708f203.svg";
export { ForwardRef as ReactComponent };